import { RangeModelComparator } from './comparators/range-model-comparator';
import {
  RangeFilterModel,
  IFilterComparator,
  ConfigureOptionsParams,
  FilterOptions,
  FilterPassParams
} from '../filter-types';
import { CalendarGridColumnName } from '../../../grid/types/column.types';
import { FilterResultFacade } from '../filter-result-facade';
import { FilterHandlerBase } from './base/filter-handler-base';

export class SizeFilterHandler extends FilterHandlerBase {
  private comparator: IFilterComparator<RangeFilterModel>;

  get name(): string {
    return CalendarGridColumnName.Size;
  }

  get isInclusiveExclusive(): boolean {
    return false;
  }

  configureFilterOptions(params: ConfigureOptionsParams): void {
    const parFilterInstance = params.api
      .getFilterInstance(this.name)
      .getFrameworkComponentInstance();
    if (parFilterInstance) {
      parFilterInstance.setOptions(
        0,
        Math.ceil(params.filterOptions.maxPar / 1000) * 1000
      );
    }
  }

  getFilterOptions(filterOptions: FilterOptions): any {
    return filterOptions.maxPar;
  }

  hasValidDiff(options: FilterOptions, grid: any, store: any): boolean {
    return this.getValidDiffComparator(options).hasValidDiff(grid, store);
  }

  getValidDiffComparator(
    options: FilterOptions
  ): IFilterComparator<RangeFilterModel> {
    if (!this.comparator) {
      this.comparator = new RangeModelComparator();
    }
    this.comparator.applyFilterOptions(this.getFilterOptions(options));
    return this.comparator;
  }
  doFilterPass(params: FilterPassParams, result: FilterResultFacade) {
    let sizeFilterPassed = true;
    const size = params.filters[this.name];
    const data = params.deal;

    if (size) {
      const model: RangeFilterModel = size.model;
      const initMaxVal = 1000000;
      const initMinVal = 1000;
      const dealResult = result.getDealFilterResult(data.id);
      const par = dealResult ? dealResult.totalPar : 0;
      if (params.context.isForwardCalendar() && par === 0) {
        sizeFilterPassed = false;
      } else if (
        model.minValue === initMinVal ||
        model.maxValue === initMaxVal
      ) {
        if (model.minValue === initMinVal) {
          sizeFilterPassed = par <= model.maxValue;
        } else if (model.maxValue === initMaxVal) {
          sizeFilterPassed = par >= model.minValue;
        }
      } else {
        sizeFilterPassed = par >= model.minValue && par <= model.maxValue;
      }
    }
    result.applyDealFilerResult(data.id, this.name, sizeFilterPassed);
    return sizeFilterPassed;
  }
}
